import React from "react";
import { Modal } from "react-bootstrap";
import { toAbsoluteUrl } from "../../../_helpers";
import SVG from "react-inlinesvg";
import { InventoryEnum } from "../../../_helpers/InventoryEnums";

export default function OrderWarningModal({ show, onHide, handleQuit }) {
  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>
          با خروج از صفحه تمام سفارشاتی که ثبت نهایی نشده‌اند حذف می‌گردد.
        </Modal.Title>
      </Modal.Header>

      <Modal.Footer>
        <div>
          <button
            type={"button"}
            onClick={onHide}
            className={"btn btn-light btn-elevate"}
          >
            لغو
          </button>
          <> </>
          <button
            type={"button"}
            onClick={handleQuit}
            className={"btn btn-primary btn-elevate"}
          >
            خروج
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
